import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-recurrent-shift-footer',
  templateUrl: './edit-recurrent-shift-footer.component.html',
  styleUrls: ['./edit-recurrent-shift-footer.component.scss'],
})
export class EditRecurrentShiftFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
